import { Timestamp } from "firebase/firestore";
import { CompanyDb } from "../database/models/CompanyDb";

export class Company {
    guid: string;
    name: string;
    isoCountryCode: string;
    licensePrependCode: string;

    createdDate: Date;
    lastModifiedDate: Date;
    deletedDate: Date | null;

    constructor(guid: string, name: string, isoCountryCode: string, licensePrependCode: string, createdDate: Date, lastModified: Date, deletedDate: Date | null) {
        this.guid = guid;
        this.name = name;
        this.isoCountryCode = isoCountryCode;
        this.licensePrependCode = licensePrependCode;
        this.createdDate = createdDate;
        this.lastModifiedDate = lastModified;
        this.deletedDate = deletedDate;
    }
}

export function CompanyToDbMapper(company: Company) {
    const mappedCompany: CompanyDb = {
        name: company.name,
        createdDate: company.createdDate,
        deletedDate: company.deletedDate,
        guid: company.guid,
        isoCountryCode: company.isoCountryCode,
        licensePrependCode: company.licensePrependCode,
        lastModifiedDate: company.lastModifiedDate,
    };
    return mappedCompany;
}

export function CompanyFromDbMapper(companyDb: CompanyDb) {
    const mappedCompany: Company = new Company(
        companyDb.guid,
        companyDb.name,
        companyDb.isoCountryCode,
        companyDb.licensePrependCode,
        companyDb.createdDate,
        companyDb.lastModifiedDate,
        companyDb.deletedDate,
    );
    return mappedCompany;
}